import { Dimensions, Platform, StatusBar, StyleSheet } from 'react-native'

import { moderateScale } from '../../styles/sizes'

export const startStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F6F2E9',
    paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0
  },
  image: {
    flex: 1,
    resizeMode: 'cover',
    justifyContent: 'center'
  },
  text: {
    color: 'white',
    fontSize: 42,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: '#000000a0'
  },
  keyboardContainerStyle: {
    flex: 1
  },
  errorMessage: {
    textAlign: 'center',
    color: 'red',
    fontSize: 12,
    fontFamily: 'GTAmerica-Regular'
  },
  passcodeInput: {
    width: '88%',
    height: 48,
    textAlign: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#E4E4E4',
    color: '#353535'
  },
  joinText: {
    textAlign: 'center',
    fontWeight: '800',
    fontSize: 16,
    fontFamily: 'GTAmerica-Medium',
    marginRight: 5,
    color: '#121212'
  },
  logo: {
    resizeMode: 'contain',
    marginBottom: 20,
    padding: 10,
    marginTop: 20
  },
  logoContainer: {
    justifyContent: 'center',
    paddingTop: 10
  },
  inputContainer: {
    marginTop: 20,
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center'
  },
  backText: {
    color: '#49CDF2',
    fontWeight: '900',
    textTransform: 'uppercase',
    fontFamily: 'GTAmerica-Medium'
  },
  enterCodeMessage: {
    fontSize: moderateScale(20),
    color: '#49CDF2',
    fontWeight: '900',
    textAlign: 'center',
    paddingHorizontal: 35,
    fontFamily: 'GTAmerica-Medium'
  },
  joinButton: {
    height: 50,
    borderRadius: 48,
    justifyContent: 'center',
    width: '100%',
    marginTop: 10,
    alignItems: 'center',
    alignSelf: 'center',
    backgroundColor: '#FFFFFF'
  },
  inputCodeStyle: {
    fontSize: moderateScale(15),
    fontWeight: '400',
    color: '#000000',
    minHeight: 40
  },
  inputCodeMsg: {
    fontSize: 14,
    textAlign: 'center',
    paddingVertical: 16,
    fontFamily: 'GTAmerica-Regular'
  },
  joinGameHeading: {
    fontSize: 32,
    textAlign: 'center',
    fontFamily: 'FeatureDeck-Medium',
    marginTop: 8
  },
  indicator: {
    position: 'absolute',
    right: 0,
    alignSelf: 'center'
  },
  noCodeMessage: {
    textAlign: 'center',
    fontSize: 14,
    fontFamily: 'GTAmerica-Regular',
    color: '#fff',
    marginTop: 10
  },
  optionView: {
    borderRadius: 5,
    width: '100%',
    height: 50,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },
  radioIcon: { height: 16, width: 16, resizeMode: 'contain', marginHorizontal: 16 },
  optionText: {
    color: '#fff',
    fontWeight: '400',
    fontSize: 18,
    fontFamily: 'GTAmerica-Regular'
  },
  optionButton: {
    width: Dimensions.get('screen').width / 2.5 - 5,
    marginHorizontal: 5,
    height: 45,
    backgroundColor: 'transparent',
    borderColor: 'white',
    borderWidth: 1,
    borderRadius: 8
  },
  // Style of Join Screen Design
  box1: {
    backgroundColor: '#480D93',
    marginVertical: 18,
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: 130,
    paddingLeft: 39,
    borderRadius: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.36,
    shadowRadius: 6.68,
    elevation: 11
  },
  box2: {
    backgroundColor: '#7B043D',
    paddingHorizontal: 29,
    paddingTop: 30,
    borderRadius: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.36,
    shadowRadius: 6.68,
    elevation: 11
  },
  title: {
    color: '#ffffff',
    fontWeight: '600',
    fontSize: 24,
    fontFamily: 'FeatureDeckApp-Regular'
  },
  discription: {
    marginTop: 5,
    color: '#ffffff',
    fontWeight: '300',
    fontSize: 12,
    fontFamily: 'GTAmerica-Regular'
  },
  inputbox: {
    marginTop: 13,
    height: 40,
    borderWidth: 1,
    borderColor: '#000000',
    backgroundColor: '#ffffff'
  },
  openTableCardContainer: {
    marginTop: 20,
    backgroundColor: '#5BC4FF',
    padding: 26,
    borderWidth: 0.5,
    borderColor: '#7E7E7E',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.36,
    shadowRadius: 6.68,
    elevation: 11,
    borderRadius: 6
  },
  communityHeader: {
    color: '#000000',
    fontWeight: '700',
    fontSize: 16,
    fontFamily: 'FeatureDeckApp-Regular',
    marginTop: 68,
    letterSpacing: 1
  },
  schedule: {
    color: '#000000',
    fontWeight: '500',
    fontSize: 14,
    fontFamily: 'GTAmerica-Medium',
    marginTop: 20,
    textAlign: 'right'
  },
  days: {
    textAlign: 'left',
    color: '#000000',
    fontWeight: 'bold',
    fontSize: 16,
    fontFamily: 'GTAmerica-Medium',
    textTransform: 'capitalize'
  },
  scheduleBox: {
    flexDirection: 'row',
    marginTop: 30
  },
  rightView: {
    flex: 1
  },
  timeStyles: {
    textAlign: 'right',
    color: '#000000',
    fontWeight: '300',
    fontSize: 14,
    fontFamily: 'GTAmerica-Regular',
    letterSpacing: 0.8
  },
  subContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  }
})
